var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tagBlock"},_vm._l((_vm.tags),function(tag,index){return _c('p',{key:index,staticClass:"small tag"},[_vm._v(_vm._s(_vm.metadata.find(x => x.id === tag).name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }